/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsBookingSequentialInput } from "../../entities/models/BookingSequentialInput";
import { z } from "zod/v4";

export const modelsBookingSequentialInputSchema = z.object({
    "child_barber_id": z.optional(z.int()),
"child_emoji": z.optional(z.string()),
"child_service_id": z.int(),
"parent_barber_id": z.optional(z.int()),
"parent_emoji": z.optional(z.string()),
"parent_service_id": z.int(),
"scheduled_start_time": z.string(),
"user_id": z.string()
    }) as unknown as z.ZodType<ModelsBookingSequentialInput>